<script>
  import { ignore } from '../../../Common/tools';
  import { External, M } from '../../../external';
  import { onDestroy, onMount } from 'svelte';
  import Checkbox from '../../../Common/Checkbox.svelte';
  import { LmsUtils } from '../../../LMS/utils/LmsUtils';

  export let valid = false, data = {}, onChange = ignore;

  let loaded = false;
  let settings;
  let circles = [];
  let groups = [];
  let orderedPages = [];
  let cachedCircles = {};

  let fillCircleGroups = async () => {
    if (!settings.circleId) {
      return;
    }

    let circle = cachedCircles[settings.circleId];
    if (!circle) {
      circle = circles.find(circle => circle.id === settings.circleId);
      circle = await LmsUtils.getCircleDetailsByUrl(circle.url);
      cachedCircles[circle.id] = circle;
    }

    if (circle?.groups?.length) {
      groups = circle.groups;
    } else {
      groups = [];
    }

    if (circle) {
      orderedPages = LmsUtils.getPagesAndGroupsInOrder(circle);
    } else {
      orderedPages = [];
    }
  };

  let triggerChange = () => {
    data.settings = [{
      key: '0',
      value: JSON.stringify(settings)
    }];
    valid = true;
    onChange();
  }

  let onCircleSelected = async () => {
    await fillCircleGroups();
    settings.groupCompleted = false;
    settings.pageCompleted = false;
    settings.groupId = '';
    settings.pageId = '';

    triggerChange();
  };

  let onCircleGroupSelected = () => {
    triggerChange();
  };

  let onCirclePageSelected = () => {
    triggerChange();
  };

  onMount(async () => {
    if (!data.settings) {
      data.settings = [];
    }
    const initialSettings = {
      circleId: '',
      groupId: '',
      pageId: '',
      groupCompleted: false,
      pageCompleted: false
    };

    if (data.settings.length && data.settings[0].value) {
      settings = JSON.parse(data.settings[0].value) || initialSettings
    } else {
      settings = initialSettings;
    }

    circles = await LmsUtils.listCircles();
    await fillCircleGroups();
    loaded = true;
  });

  onDestroy(() => {
    settings = null;
    cachedCircles = null;
  });

</script>

{#if loaded}
  <div class='col20 f-left small-rules mb-25'>
    <h4 class='col20 f-left mt-15 mb-10 t-center' style='line-height:1.4;'>{M.TRIGGER_CIRCLE_COMPLETED_DESC}</h4>
    <div class='popup-input-wrapper f-left mb-5'>
      <div class='info'>
        <h5>{M.CIRCLE}</h5>
      </div>
      <select class='page-select' bind:value={settings.circleId} on:change={onCircleSelected}>
        <option disabled value="">{M.SELECT_CIRCLE}</option>
        {#each circles as circle}
          <option value={circle.id}>{circle.name} ({circle.published ? M.PUBLISHED : M.NOT_PUBLISHED})</option>
        {/each}
      </select>
    </div>

    {#if groups.length && !settings.pageCompleted}
      <div class='popup-input-wrapper mb-5 f-left'>
        <Checkbox clz="f-left col20" bind:data={settings.groupCompleted} label='{M.LIMIT_TO_GROUP_TITLE}'
                  description="{M.TRIGGER_LIMIT_TO_GROUP_DESC}" />
        {#if settings.groupCompleted}
          <div class='info mt-15'>
            <h5>{M.CIRCLE_GROUP}</h5>
          </div>
          <select class='page-select' bind:value={settings.groupId} on:change={onCircleGroupSelected}>
            {#if !settings.groupId}
              <option disabled value="">{M.SELECT_CIRCLE_GROUP}</option>
            {/if}
            {#each groups as group}
              <option value={group.pageGroup.id}>{group.pageGroup.name}</option>
            {/each}
          </select>
        {/if}
      </div>
    {/if}

    {#if !settings.groupCompleted}
      <div class='popup-input-wrapper mb-5 f-left'>
        <Checkbox clz="f-left col20" bind:data={settings.pageCompleted} label='{M.LIMIT_TO_PAGE_TITLE}'
                  description="{M.TRIGGER_LIMIT_TO_PAGE_DESC}" />
        {#if settings.pageCompleted}
          <div class='info mt-15'>
            <h5>{M.PAGE}</h5>
          </div>
          <select class='page-select' bind:value={settings.pageId} on:change={onCirclePageSelected}>
            {#if !settings.pageId}
              <option disabled value="">{M.SELECT_PAGE_TITLE}</option>
            {/if}
            {#each orderedPages as item}
              {#if item.pageGroup}
                <optgroup label="{item.pageGroup.name}">
                  {#each item.pages as page}
                    <option value="{page.id}"> {page.name}</option>
                  {/each}
                </optgroup>
              {:else}
                <option value={item.id}>{item.name}</option>
              {/if}
            {/each}
          </select>
        {/if}
      </div>
    {/if}
  </div>
{/if}
